import React, { useState } from "react";
import SearchDropDown from "../common/SearchDropDown";
import { SEARCH_TYPE } from "../../constant";

export default function CampaignSearch({val, setVal}) {
  
  const [value, setValue] = useState([]);

  return (
    <SearchDropDown
      mode="multiple"
      placeholder="Campaigns"
      onChange={(newValue) => {
        setValue(newValue);
      }}
      type={SEARCH_TYPE.CAMPAIGN}
      val={val}
      setVal={setVal}
      style={{
        width: "120px",
      }}
    />
  );
}
